// Titulo de la vista actual segun la ruta. Lo usan la barra superior
// (AppHeader) y el modulo "Solicitar cambio" para mostrar exactamente lo mismo.
import { MODULOS_BY_KEY } from "../../constants/modulos";

const EXTRA = [
  { path: "/app/home", label: "Inicio" },
  { path: "/app/perfil", label: "Perfil" },
];

export function getTituloVista(pathname) {
  const all = [...EXTRA, ...Object.values(MODULOS_BY_KEY)];
  const match = all.find((m) => pathname === m.path || pathname.startsWith(`${m.path}/`));
  return match?.label || "";
}
